var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-docs",class:{grey: _vm.greyBackground},on:{"click":_vm.createDoc}},[_c('div',{staticClass:"no-docs-ellipse"},[_c('div',{staticClass:"no-docs-ellipse--icon"},[_c('no-docs-icon')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }